import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableGroupingOuterContainerStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  overflowX: 'auto',
});

export const TableGroupingHeaderGridStyled = styled('div')<{
  $gridTemplateColumns: string;
}>(({ theme, $gridTemplateColumns }) => ({
  display: 'grid',
  gridTemplateColumns: $gridTemplateColumns,
  padding: '0 16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  alignItems: 'center',
}));

export const TableGroupingHeaderCellStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(0.7, 2),
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.text.secondary,
}));

export const TableGroupingExpandHeaderCellStyled = styled('div')<{ $right?: number }>(
  ({ theme, $right = 0 }) => ({
    position: 'sticky',
    right: $right,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
  }),
);

export const TableGroupingGroupContainerStyled = styled('div')(({ theme }) => ({
  minWidth: 'max-content',
  padding: 8,
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

export const TableGroupingGroupHeaderStyled = styled('div')<{ $isExpanded: boolean }>(
  ({ theme, $isExpanded }) => ({
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.background.bgSecondarySubtle,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    cursor: 'pointer',
    userSelect: 'none',
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: $isExpanded ? 0 : 8,
    borderBottomRightRadius: $isExpanded ? 0 : 8,
  }),
);

export const TableGroupingCardsGridStyled = styled('div')<{
  $gridTemplateColumns: string;
  // Flat (ungrouped) buckets have no real group, so they drop the group surface.
  $flat?: boolean;
}>(({ theme, $gridTemplateColumns, $flat }) => ({
  display: 'grid',
  gridTemplateColumns: $gridTemplateColumns,
  rowGap: theme.spacing(1),
  padding: 8,
  ...(!$flat && {
    backgroundColor: theme.palette.background.bgSecondarySubtle,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  }),
}));

export const TableGroupingRowStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== '$isSelected',
})<{ $isSelected?: boolean }>(({ theme, $isSelected }) => ({
  display: 'grid',
  gridColumn: '1 / -1',
  gridTemplateColumns: 'subgrid',
  borderRadius: 8,
  transition: 'box-shadow 0.2s ease-in-out',
  boxShadow: $isSelected
    ? `inset 0 0 0 1px ${theme.palette.primary.main}, 0px 1px 2px 0px rgba(10, 13, 18, 0.05)`
    : `inset 0 0 0 0px ${theme.palette.primary.main}, 0px 1px 2px 0px rgba(10, 13, 18, 0.05)`,
  backgroundColor: theme.palette.background.paper,
}));

export const TableGroupingCellStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.text.primary,
  fontSize: theme.typography.body2.fontSize,
}));

export const TableGroupingExpandCellStyled = styled('div')<{ $right?: number }>(
  ({ theme, $right = 0 }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0.5),
    position: 'sticky',
    right: $right,
    zIndex: 1,
    backgroundColor: theme.palette.background.paper,
    borderTopRightRadius: $right === 0 ? 8 : 0,
    borderBottomRightRadius: $right === 0 ? 8 : 0,
  }),
);

export const TableGroupingRowExpandStyled = styled('div')({
  gridColumn: '1 / -1',
  padding: 8,
});

export const TableGroupingEmptyStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(6, 2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export const TableGroupingCheckboxStyled = styled(Checkbox)({
  width: 0,
  height: 0,
});
